import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-rating',
  template: `
    <div class="star-container">
      <ng-container *ngFor="let star of stars; let i = index">
        <div class="icon rating-star" [class.rating-star_filled]="i < rating"></div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      .star-container {
        display: flex;
        align-content: center;
        gap: 4px;
      }
    `
  ]
})

export class RatingComponent {
  @Input() rating: number | null = 0;
  stars = Array(5).fill(0);
}
